import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../CustomerValueAgreements.module.scss';
import { CvaListHeadingProps } from '../../types';

export const CVAListHeading = ({ children }: CvaListHeadingProps) => {
  return (
    <CatHeading variant="body">
      <span className={styles['cva-modal-wrapper--list-heading']}>
        {children}
      </span>
    </CatHeading>
  );
};
